/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDmvsPotvrzeniEditaceRequest } from '../types/PatchedDmvsPotvrzeniEditace';
import type { DmvsPotvrzeniEditaceResponse } from '../types/DmvsPotvrzeniEditace';

export type DmvsDtiDocsNotifyClosePartialUpdateRequest = PatchedDmvsPotvrzeniEditaceRequest;
export type DmvsDtiDocsNotifyClosePartialUpdateResponse = DmvsPotvrzeniEditaceResponse;

export type DmvsDtiDocsNotifyClosePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dmvs_dti_docs/{id}/notify_close/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_notify_close_partial_update
 * tags:
 *   - dmvs_dti_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsPotvrzeniEditace'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsPotvrzeniEditace'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsPotvrzeniEditace'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsPotvrzeniEditace'
 *     description: ''
 * ```
 */
export const dmvsDtiDocsNotifyClosePartialUpdateOperation = ({
  id,
  ...rest
}: DmvsDtiDocsNotifyClosePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dmvs_dti_docs/${id}/notify_close/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dmvs_dti_docs/{id}/notify_close/' };
  };

/**
 * PATCH /dmx-server/dmvs_dti_docs/{id}/notify_close/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_notify_close_partial_update
 * tags:
 *   - dmvs_dti_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsPotvrzeniEditace'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsPotvrzeniEditace'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsPotvrzeniEditace'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsPotvrzeniEditace'
 *     description: ''
 * ```
 */
export const dmvsDtiDocsNotifyClosePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsDtiDocsNotifyClosePartialUpdateQuery;
  request: PatchedDmvsPotvrzeniEditaceRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DmvsPotvrzeniEditaceResponse>> => {
  const operation = dmvsDtiDocsNotifyClosePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
